import api from './api';

export interface AppSetting {
  key: string;
  value: string;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

export const settingsService = {
  async getAll(): Promise<AppSetting[]> {
    const response = await api.get<AppSetting[]>('/admin/settings');
    return response.data;
  },

  async update(key: string, value: string): Promise<AppSetting> {
    const response = await api.put<AppSetting>(
      `/admin/settings/${encodeURIComponent(key)}`,
      { value },
    );
    return response.data;
  },
};
